<template>
  <div
    v-if="active"
    class="canvas-paint"
    data-gwmenu="noclose"
    @click.stop
    @mouseup="mouseUpEventHandler"
    @mousemove="mouseMoveEventHandler"
    @mousedown="mouseDownEventHandler"
    @touchstart="touchstartEventHandler"
    @touchmove="touchMoveEventHandler"
    @touchend="mouseUpEventHandler"
  >
    <div class="canvas-paint_controls text-noselect">
      <GwMessage
        class="no-events"
        :message="{
          hide: true,
        }"
        style="
          --clr-back: var(--clr-yellow);
          --back-padding: 0.25rem 2rem;
          --back-opacity: 0.75;
          top: 1rem;
          position: relative;
        "
      >
        <template #icon>
          <i
            class="mdi mdi-pencil text-large"
            :style="'color:var(--clr-white)'"
          ></i>
        </template>
        <template #default>
          <div class="weight_500">
            {{ $t('canvas.title') }}
          </div>

          <div
            class="clr-grey ml-4"
            v-html="
              $t('canvas.press_key_exit', {
                key: hotkeys.drawing_mode.displayCombination,
              })
            "
          ></div>
        </template>
      </GwMessage>
    </div>
    <canvas
      v-if="active"
      id="sheet_painter"
      :width="viewport.width"
      :height="viewport.height"
    ></canvas>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import GwMessage from '@/components/Messages/GwMessage'

export default {
  name: 'CanvasPaint',
  components: {
    GwMessage,
  },
  data() {
    return {
      active: false,
      activated: false,
      canvas: null,
      context: null,
      clickX: [],
      clickY: [],
      clickDrag: [],
      paint: null,
    }
  },
  mounted() {
    this.inicialize()
  },
  methods: {
    inicialize() {
      if (this.active) {
        nextTick(() => {
          const canvas = document.getElementById('sheet_painter')
          const context = canvas.getContext('2d')
          context.strokeStyle = 'yellow'
          context.lineJoin = 'round'
          context.lineWidth = 3
          this.context = context
          this.canvas = canvas
        })
      } else {
        this.context = null
        this.canvas = null
        this.clickX = []
        this.clickY = []
        this.clickDrag = []
        this.paint = null
      }
    },
    toggle() {
      this.active = !this.active
      this.inicialize()
    },
    addClick(x, y, dragging) {
      this.clickX.push(x)
      this.clickY.push(y)
      this.clickDrag.push(dragging)
    },
    drawNew() {
      const i = this.clickX.length - 1
      if (!this.clickDrag[i]) {
        if (this.clickX.length === 0) {
          this.context.beginPath()
          this.context.moveTo(this.clickX[i], this.clickY[i])
          this.context.stroke()
        } else {
          this.context.closePath()

          this.context.beginPath()
          this.context.moveTo(this.clickX[i], this.clickY[i])
          this.context.stroke()
        }
      } else {
        this.context.lineTo(this.clickX[i], this.clickY[i])
        this.context.stroke()
      }
    },
    mouseDownEventHandler(e) {
      this.paint = true
      const x = e.pageX - this.canvas.offsetLeft
      const y = e.pageY - this.canvas.offsetTop
      if (this.paint) {
        this.addClick(x, y, false)
        this.drawNew()
      }
    },
    touchstartEventHandler(e) {
      this.paint = true
      if (this.paint) {
        this.addClick(
          e.touches[0].pageX - this.canvas.offsetLeft,
          e.touches[0].pageY - this.canvas.offsetTop,
          false,
        )
        this.drawNew()
      }
    },
    mouseUpEventHandler(e) {
      this.context.closePath()
      this.paint = false
    },

    mouseMoveEventHandler(e) {
      const x = e.pageX - this.canvas.offsetLeft
      const y = e.pageY - this.canvas.offsetTop
      if (this.paint) {
        this.addClick(x, y, true)
        this.drawNew()
      }
    },

    touchMoveEventHandler(e) {
      if (this.paint) {
        this.addClick(
          e.touches[0].pageX - this.canvas.offsetLeft,
          e.touches[0].pageY - this.canvas.offsetTop,
          true,
        )
        this.drawNew()
      }
    },
  },
  computed: {
    viewport() {
      return this.$store.getters.globals_window_size
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
  },
  watch: {
    hotkeysPressed(keys) {
      if (!keys) return
      const hotkeyActions = {
        drawing_mode_open: {
          keys: this.hotkeys.drawing_mode.keyCombination,
          fn: () => this.toggle(),
        },
        ...(this.active
          ? { drawing_mode_close: { keys: ['escape'], fn: () => this.toggle() } }
          : {}),
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
    viewport() {
      this.inicialize()
    },
  },
}
</script>
<style lang="scss" scoped>
.canvas-paint {
  height: 0;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  pointer-events: all !important;
  border: 2px solid var(--clr-yellow);
  height: 100vh;
  z-index: var(--z-index-canvas-paint);
  &_controls {
    opacity: 0;
    transition: 0.3s;
    position: absolute;
    animation: showHide 1s;
    @keyframes showHide {
      0% {
        opacity: 1;
      }
      88% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    &:hover {
      opacity: 1;
    }
    &::before {
      content: '';
      height: 10rem;
      width: 100vw;
      position: fixed;
      left: 0;
      top: 0;
    }
  }
}
</style>
